import { Columns } from '@domain-group/suit-theme'

import useProviderPriceList from '@hooks/useProviderPriceList'

import Agencies from '../Agencies'
import Bundles from '../Bundles'
import FavouriteOrders from '../FavouriteOrders'
import ForkedPriceLists from '../ForkedPriceLists'
import Packages from '../Packages'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  providerPriceListId: number,
}

const PageContent = (props: PageContentProps) => {
  const { providerPriceListId } = props

  const providerPriceListPayload = useProviderPriceList({ id: providerPriceListId })

  return (
    // @ts-expect-error TS2741
    <PageLayout providerPriceListPayload={providerPriceListPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <Agencies providerPriceListId={providerPriceListId} />

        <Bundles providerPriceListId={providerPriceListId} />

        <FavouriteOrders providerPriceListId={providerPriceListId} />

        <ForkedPriceLists providerPriceListId={providerPriceListId} />

        <Packages providerPriceListId={providerPriceListId} />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
